import { render } from "./FooterInternas.vue?vue&type=template&id=19cd65f0&scoped=true"
import script from "./FooterInternas.vue?vue&type=script&lang=js"
export * from "./FooterInternas.vue?vue&type=script&lang=js"

import "./FooterInternas.vue?vue&type=style&index=0&id=19cd65f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cd65f0"]])

export default __exports__